import { BoxConstraints, EdgeInsets, Pad, RenderBox } from '../rendering'

import { ReactNode } from 'react'
import { renderElement } from '../document'

export class PaddingRenderBox extends RenderBox<{ padding: EdgeInsets }> {
  performLayout(parent: BoxConstraints) {
    const p = this.props.padding
    const child = this.children[0]

    if (child) {
      // 1. Lay out the child with constraints deflated by the padding.
      child.performLayout(BoxConstraints.deflate(parent, p))

      // 2. Raw size is child size + padding.
      const raw = {
        width: child.box.width + p.left + p.right,
        height: child.box.height + p.top + p.bottom
      }

      // 3. Clamp that raw size to the parent constraints.
      const clamped = BoxConstraints.constrain(parent, raw)

      this.box = { x: 0, y: 0, ...clamped }

      // Position child inside the padding rectangle.
      child.box.x = p.left
      child.box.y = p.top
    } else {
      // No child: the padding rectangle itself, clamped.
      const raw = { width: p.left + p.right, height: p.top + p.bottom }
      const clamped = BoxConstraints.constrain(parent, raw)
      this.box = { x: 0, y: 0, ...clamped }
    }
  }
}

export function Padding({
  padding,
  children
}: {
  padding: EdgeInsets | number
  children: ReactNode
}) {
  const edgeInsets = normalizePadding(padding)

  return renderElement(new PaddingRenderBox({ padding: edgeInsets }), children)
}

function normalizePadding(padding: EdgeInsets | number): EdgeInsets {
  if (typeof padding === 'number') {
    return { left: padding, right: padding, top: padding, bottom: padding }
  }
  return padding
}
